/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbPostRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getCmdbPermsPrincipalUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbConfigReferenceTypeUrl.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { ActionApi, PrincipalsForRolesResponse } from './ActionApi.types.tsx';

export const fetchPrincipalsForRoles =
	(roleIds: string[]): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		if (state.dataManager.rolesLoading) {
			return;
		}
		setState({
			...state,
			dataManager: { ...state.dataManager, rolesLoading: true },
		});

		try {
			const requestBody = {
				roleIds,
				resourceId: `ari:cloud:cmdb::workspace/${workspaceId}`,
			};

			const principalIdsForRoles: PrincipalsForRolesResponse = await performCmdbPostRequest(
				getCmdbPermsPrincipalUrl(workspaceId),
				{
					body: JSON.stringify(requestBody),
				},
			);

			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								rolesData: principalIdsForRoles.results,
								rolesLoading: false,
							},
						}
					: {
							dataManager: {
								...state.dataManager,
								rolesData: principalIdsForRoles.results,
								rolesLoading: false,
							},
						},
			);
			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchPrincipalsForRoles succeeded');
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState(
				fg('aurum_dm_settings_stale_state_fix')
					? {
							...getState(),
							dataManager: {
								...getState().dataManager,
								rolesLoading: false,
								rolesError: error,
							},
						}
					: {
							...state,
							dataManager: { ...state.dataManager, rolesLoading: false, rolesError: error },
						},
			);
			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchPrincipalsForRoles',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
				},
				error,
			});

			throw error;
		}
	};
